
import { Component, Prop, Vue } from "vue-property-decorator";
import { HousfyStoryboard } from "housfy-ui-lib";
import MyHousfyConfig from "@/services/MyHousfyConfig";

interface IProcessData {
  env: string;
  googleApi: string;
}

@Component({
  components: { HousfyStoryboard },
})
export default class Storyboard extends Vue {
  @Prop({ type: String, default: null })
  title?: string;

  processData: IProcessData = {
    env: MyHousfyConfig.env().ENVIRONMENT,
    googleApi: "",
  };
}
